document.addEventListener('DOMContentLoaded', function () {
  const alphabetButtons = document.querySelectorAll('.alphabet-filter__btn');
  const collectionItems = document.querySelectorAll('.collection-card');

  // Initially show all alphabet buttons with default opacity
  alphabetButtons.forEach(button => {
    button.style.opacity = '1'; // Fully opaque
    button.style.pointerEvents = 'auto'; // Enable click events
  });

  // Set to keep track of letters and numbers with associated collections
  const lettersWithCollections = new Set();
  
  collectionItems.forEach(item => {
    const title = item.querySelector('.collection-card__title').innerText.trim().toUpperCase();
    if (title.length > 0) {
      const firstLetter = title.charAt(0);
      if (/[A-Z]/.test(firstLetter)) {
        lettersWithCollections.add(firstLetter); // Add letters
      } else if (/[0-9]/.test(firstLetter)) {
        lettersWithCollections.add('NUM'); // Group numbers under "NUM"
      }
    }
  });

  // Fade out buttons for letters without associated collections
  alphabetButtons.forEach(button => {
    const letter = button.getAttribute('data-letter');
    if (!lettersWithCollections.has(letter) && letter !== 'ALL' && letter !== 'NUM') {
      button.style.opacity = '0.5'; // Fade out
      button.style.pointerEvents = 'none'; // Disable click events
    }
  });

  // Alphabet filter functionality
  alphabetButtons.forEach(button => {
    button.addEventListener('click', function () {
      const letter = button.getAttribute('data-letter');

      // Show only the section corresponding to the clicked letter and hide all others
      document.querySelectorAll('.alphabet-section').forEach(section => {
        const sectionLetter = section.getAttribute('data-letter');

        // If it's the "NUM" button, check if the collection starts with a number (0-9)
        if (letter === 'NUM') {
          const showCollection = Array.from(section.querySelectorAll('.collection-card')).some(item => {
            const title = item.querySelector('.collection-card__title').innerText.trim();
            return /^[0-9]/.test(title); // Check if the collection starts with a number
          });

          // Show or hide the section based on whether it has collections starting with a number
          section.style.display = showCollection ? 'block' : 'none';
        } else if (sectionLetter === letter || letter === 'ALL') {
          section.style.display = 'block'; // Show the selected section
        } else {
          section.style.display = 'none'; // Hide all other sections
        }
      });
    });
  });
});
